import * as React from 'react';
import styled from 'styled-components';
import {mixinBtnBorder, mixinBtnLarge, mixinResetBtnCss, mixinWithBtnPropsFn, IBtnDefaultProps} from "./btn_mixin";

interface IProps
    extends IBtnDefaultProps, React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
}

const BtnBorderLargeDefault: React.FC<IProps> = (props) => {

    const { icon, widthSize, ...ButtonProps } = props;

    return (<button {...ButtonProps} />)

};

const BtnBorderLarge = styled(BtnBorderLargeDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnLarge}
    ${mixinBtnBorder}
    
    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnBorderLarge



// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_border_large.tsx